import { cn } from '@/lib/cn'

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('size-8', className)} aria-hidden="true" focusable="false">
      <rect width="32" height="32" rx="9" fill="var(--color-volt)" />
      <path
        d="M9.5 10h13l-13 12h13"
        fill="none"
        stroke="var(--color-volt-ink)"
        strokeWidth="3.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="24.5" cy="6.5" r="2" fill="var(--color-volt-ink)" opacity="0.85" />
    </svg>
  )
}

export function Logo({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <LogoMark />
      <span className="font-display text-[1.375rem] leading-none font-bold tracking-[-0.03em]">zarcade</span>
    </span>
  )
}
